import { get } from 'utils/fetchRequest';

// Бүх public тохиргоог нэг object болгож татах
// Жишээ хариу:
// { fast_delivery_price: 23000, regular_delivery_price: 0 }
export const getSettings = async () => {
    try {
        const result = await get('settings');
        return result;
    } catch (err) {
        return { error: err };
    }
};

// Нэг key-ээр тохиргоог татах
export const getSetting = async (key) => {
    try {
        const result = await get(`settings/${key}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

// Reducer action type
export const SET_SETTINGS = 'SET_SETTINGS';
